import BaseServiceCrud from './BaseServiceCrud';

export default class InternalUserService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'bo-user';
    }

    getCriteria(criteria) {
        return this.objToQueryString({
            group_id_excluded: criteria.groupIdExcluded,
            email: criteria.email,
            name: criteria.name,
            status: criteria?.status?.enumValue,
            invited_only: criteria.onlyInvitedUsers,
            first_result: criteria.firstResult,
            max_result: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
        });
    }
    getDetailsList(criteria) {
        const queryString = this.getCriteria(criteria);
        return this.fetch(`${this.domain}/${this.path}/details/list${queryString}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    get(id, invitation) {
        return this.fetch(`${this.domain}/${this.path}/${id}/${invitation}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    removeAccount(id) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/remove/${id}`, {
            method: 'PUT',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    removeInvitation(id) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/invitation/${id}`, {
            method: 'DELETE',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    update(id, request) {
        return this.fetch(`${this.domain}/${this.path}/${id}`, {
            method: 'PUT',
            body: JSON.stringify(request),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    create(request) {
        return this.fetch(`${this.domain}/${this.path}/create`, {
            method: 'POST',
            body: JSON.stringify(request),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getUserAvatar(userId) {
        return this.fetch(`${this.domain}/${this.path}/${userId}/avatar/user`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    blockAccount(id) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/block/${id}`, {
            method: 'PATCH',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    unblockAccount(id) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/unblock/${id}`, {
            method: 'PATCH',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    getImportHistoryList() {
        return this.fetch(`${this.domain}/${this.path}/userImportHistory`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    upload(e) {
        const formData = new FormData();
        formData.append('file', e.files[0]);
        return this.fetch(`${this.domain}/${this.path}/upload`,
            {
                method: 'POST',
                body: formData,
            },
            {
                //'Content-Type': 'multipart/form-data',
            }
        ).then((res) => {
            return Promise.resolve(res);
        });
    }

    getTimelineCriteria(type, firstResult, maxResults, dateStart, dateEnd) {
        return this.objToQueryString({
            type: type,
            first_result: firstResult,
            max_results: maxResults,
            date_start: dateStart,
            date_end: dateEnd
        });
    }

    getUserTimeline(userId, type, firstResult, maxResults, dateStart, dateEnd) {
        const queryString = this.getTimelineCriteria(type, firstResult, maxResults, dateStart, dateEnd);
        return this.fetch(`${this.domain}/${this.path}/${userId}/timeline${queryString}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getUserTimelineSummary(userId, type, dateStart, dateEnd) {
        const queryString = this.getTimelineCriteria(type, null, null, dateStart, dateEnd);
        return this.fetch(`${this.domain}/${this.path}/${userId}/timeline/summary${queryString}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getUserChallenges(userId, firstResult, maxResults) {
        const queryString = this.objToQueryString({
            first_result: firstResult,
            max_results: maxResults,
        });
        return this.fetch(`${this.domain}/${this.path}/${userId}/challenges${queryString}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    finishUserChallenge(userId, challengeId) {
        return this.fetch(`${this.domain}/${this.path}/${userId}/challenges/${challengeId}/finish`, {
            method: 'POST',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    resetWalletPoints(request) {
        return this.fetch(`${this.domain}/${this.path}/reset-wallet-points`, {
            method: 'POST',
            body: JSON.stringify(request),
        }).then((res) => Promise.resolve(res));
    }
}
